import { Component, OnInit, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ContactListContactModel, CustomFieldJson } from '../contact-list-contacts/contact-list-contacts.model';
import { HttpRepositoryService } from '../../../core/http-repository.service';
import { AntiForgeryTokenService } from '../../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../../nav-menu/user-company.service';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'contact-list-contacts-edit',
  templateUrl: './contact-list-contacts-edit.component.html',
  styleUrls: ['./contact-list-contacts-edit.component.css']
})

export class ContactListContactsEditComponent implements OnInit, OnDestroy {

  private contactListContact: ContactListContactModel = new ContactListContactModel(0, 0, 0, null, null, []);
  private isNew: boolean = true;
  private modal: any;
  private oldCustomFields: CustomFieldJson[] = [];
  private selectedCompany: number;
  private subs = new SubSink();

  @ViewChild('editForm', { static: false }) editForm: NgForm;

  @Output()
  private saved: EventEmitter<ContactListContactModel> = new EventEmitter<ContactListContactModel>();

  ngOnInit(): void {
    this.modal = $('#contactListContactForm');

    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpRes => {
      this.selectedCompany = cmpRes;
    })
  }

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService, private companyService: UserCompanyService) { }

  public show(contact: ContactListContactModel, isNew: boolean, oldCustomFields?: CustomFieldJson[]) {
    this.editForm.reset();
    this.contactListContact = contact;
    this.isNew = isNew;
    this.oldCustomFields = oldCustomFields;

    this.contactListContact.customFieldsJson.forEach(function (field) {
      if (field.value == 'false')
        field.value = '';
    });

    this.modal.modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  private update(): void {
    let editModel: ContactListContactModel = this.contactListContact;

    this.oldCustomFields.forEach(function (item) {
      let field = editModel.customFieldsJson.find(x => x.idCustomField == item.idCustomField)

      if (!field) {
        editModel.customFieldsJson.push(item);
      }
    });

    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Edit assign contact', 'error');
      } else {
        this.subs.sink = this.repository.post<ContactListContactModel>('api/Contact/EditAssign?companyId=' + this.selectedCompany, editModel, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Edit assign contact', 'error');
          } else {
            Toast.Show('Contact assign edited successfully.', 'Edit assign contact', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private insert(): void {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Assign contact', 'error');
      } else {
        this.subs.sink = this.repository.post<ContactListContactModel>('api/Contact/CreateAssign?companyId=' + this.selectedCompany, this.contactListContact, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Assign contact', 'error');
          } else {
            Toast.Show('Contact assigned successfully.', 'Assign contact', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private onSaveCompleted(data: ContactListContactModel) {
    this.close();
    this.saved.emit(data);
  }

  private save() {
    if (this.editForm.valid) {
      if (this.isNew) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      Object.keys(this.editForm.controls)
        .forEach(fieldName => {
          this.editForm.controls[fieldName].markAsDirty();
        });
      $('#email').focus();
    }
  }

  close() {
    this.editForm.reset();
    this.contactListContact = new ContactListContactModel(0, 0, 0, null, null, []);
    this.modal.modal('hide');
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
